import RadioGroup from './radio-group';

/* istanbul ignore next */
RadioGroup.install = function(Vue) {
  Vue.component(RadioGroup.name, RadioGroup);
};

export default RadioGroup;
